module.exports = __webpack_public_path__ + "img/cases-brand-vive-lazyload-11.3505785e.jpg";